<div class="text-center grid gap-4 max-w-2xl">
  <div class="mb-5 text-5xl font-bold">
    {{ 'paymentSplit:selectBeneficiaryTitle' | translate }}
  </div>
  <div class="">
    {{ 'paymentSplit:selectBeneficiarySubtitle' | translate }}
  </div>

  <form class="grid gap-2" [formGroup]="splitPayment">
    <ng-container formArrayName="splits">
      <div *ngFor="let split of splits; index as i" class="w-full">
        <div [formGroup]="split" class="mb-4">
          <ew-providers-list
            [width]="'100%'"
            [value]="split.value.beneficiary"
            (valueChanged)="
              split.get('bankAccount')?.setValue($event);
              onInputValueChange(split)
            "
            [label]="getBeneficiaryLabel(i + 1)"
            [currency]="currency">
          </ew-providers-list>

          <div
            class="w-full flex flex-row content-center justify-start flex-wrap remove-bottom-margin">
            <mat-form-field>
              <mat-label>
                {{ 'paymentDetails:paymentType' | translate }}
                <small>({{ 'shared:required' | translate }})</small>
              </mat-label>
              <mat-select
                formControlName="type"
                [placeholder]="'paymentDetails:paymentType' | translate"
                (selectionChange)="
                  split.get('amount')?.setValue(0);
                  split.get('inputValue')?.setValue(null);
                  split.get('rate')?.setValue(null)
                ">
                <mat-option value="amount">{{
                  'paymentDetails:paymentCardAmount' | translate
                }}</mat-option>
                <mat-option value="percentage">{{
                  'paymentSplit:percentage' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="grow">
              <mat-label>
                {{ 'paymentSplit:paymentSplit' | translate }}
                <small>({{ 'shared:required' | translate }})</small>
              </mat-label>
              <input
                ewPreventScroll
                mask="separator.2"
                thousandSeparator=","
                decimalMarker="."
                matInput
                class="text-right"
                formControlName="inputValue"
                (blur)="onInputValueChange(split)" />
              <span matTextSuffix *ngIf="split.value.type == 'amount'">{{
                currency
              }}</span>
              <span matTextSuffix *ngIf="split.value.type == 'percentage'"
                >%</span
              >
            </mat-form-field>
          </div>

          <div
            class="w-full flex flex-row justify-start flex-wrap mb-2.5 mt-1 ml-1">
            <p class="font-extralight text-sm">
              {{ 'paymentSplit:beneficaryDeposit' | translate }}:
              {{ split.value.rate?.amountTo | currency }}
              {{ split.value.rate?.dstCurrency }}
            </p>
          </div>

          <div
            class="w-full flex flex-row content-center justify-start flex-wrap remove-bottom-margin">
            <mat-form-field class="grow">
              <mat-label>
                {{ 'transactions:reference' | translate }}
                <small>({{ 'shared:required' | translate }})</small>
              </mat-label>
              <input matInput formControlName="reference" />
            </mat-form-field>
          </div>

          <div
            class="w-full flex flex-row justify-start flex-wrap mb-2.5 mt-1 ml-1">
            <p class="font-extralight text-sm">
              {{ 'paymentSplit:beneficaryReferenceDescription' | translate }}
            </p>
          </div>

          <div class="text-left">
            <button
              *ngIf="splits.length > 1"
              class="rounded-lg xs:w-full w-40"
              mat-stroked-button
              color="primary"
              (click)="removeBeneficiary(i)">
              <i class="fa-regular fa-trash"></i>
              {{ 'paymentSplit:removeBeneficiary' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div>
        <button
          class="rounded-lg xs:w-full w-40"
          mat-stroked-button
          color="primary"
          (click)="addBeneficiary()">
          {{ 'paymentSplit:addExtraBenerficiary' | translate }}
        </button>
      </div>
    </ng-container>

    <div class="text-center">
      <p class="text-lg text-red-500 mt-2" *ngIf="totalAmount > budget">
        {{ 'paymentSplit:budget' | translate }}
      </p>
    </div>
  </form>
</div>
